// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__du8pg","rotate":"spinner_rotate__gN4RJ","spinner1":"spinner_spinner1__GOVRF"};